export const ERROR_STATUS = {
    ELEMENT_MISSING: 'Element is missing',
    UNEXPECTED_ERROR: 'Unexpected error while entering PIP',
    NOT_SUPPORTED: 'PIP not supported',
    ALREADY_EXITED: 'PIP Already Exited',
}

const PIPUtilHelper = () => {
    let isPIPexited = false

    const onPIPleave = () => {
        isPIPexited = true
    }

    const enterPIP = elem => {
        return new Promise((resolve, reject) => {
            if (elem) {
                isPIPexited = false
                if ('pictureInPictureElement' in document) {
                    elem.requestPictureInPicture()
                        .then(PIPsuccessData => {
                            elem.addEventListener(
                                'leavepictureinpicture',
                                onPIPleave,
                                false
                            )
                            resolve(PIPsuccessData)
                        })
                        .catch(error => {
                            reject(ERROR_STATUS.UNEXPECTED_ERROR)
                        })
                } else {
                    reject(ERROR_STATUS.NOT_SUPPORTED)
                }
            } else {
                reject(ERROR_STATUS.ELEMENT_MISSING)
            }
        })
    }

    const exitPIP = elem => {
        return new Promise((resolve, reject) => {
            if (elem) {
                elem.removeEventListener('leavepictureinpicture', onPIPleave)
                if (isPIPexited) {
                    resolve(ERROR_STATUS.ALREADY_EXITED)
                } else {
                    if (document.pictureInPictureElement) {
                        document
                            .exitPictureInPicture()
                            .then(PIPExitData => {
                                resolve(PIPExitData)
                            })
                            .catch(error => {
                                reject(ERROR_STATUS.UNEXPECTED_ERROR)
                            })
                    } else {
                        resolve(ERROR_STATUS.ALREADY_EXITED)
                    }
                }
            } else {
                reject(ERROR_STATUS.ELEMENT_MISSING)
            }
        })
    }

    return {
        enterPIP,
        exitPIP,
    }
}

const PIPUtil = PIPUtilHelper()

export default PIPUtil
